<script setup lang="ts">
import { loginRedirect } from "@/auth/msal";
import Spinner from "@/components/Spinner.vue";
import { ref } from "vue";

const busy = ref(false);

async function onSignIn() {
  busy.value = true;
  try {
    await loginRedirect();
  } finally {
    // If loginRedirect resolves without navigating (shouldn't), reset.
    busy.value = false;
  }
}
</script>

<template>
  <main class="mx-auto flex min-h-[70vh] max-w-md flex-col items-center justify-center px-6 text-center">
    <h1 class="text-xl font-medium">operate-playground</h1>
    <button
      type="button"
      class="mt-6 inline-flex items-center gap-2 rounded bg-accent px-4 py-2 text-sm font-medium text-white hover:opacity-90 dark:bg-accent-dark"
      :disabled="busy"
      @click="onSignIn"
    >
      <Spinner v-if="busy" :size="14" /> Sign in with Microsoft
    </button>
    <p class="mt-3 text-2xs text-fg-muted">Operate employees only.</p>
  </main>
</template>
